import { useState } from 'react';
import styles from './IndividualNavbar.module.css';

function IndividualNavbar() {

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);

    };


    return (

        <div className={styles.container} data-testid="individual-navbar">
            <div className={styles.hamburger} onClick={toggleMenu}>
                <div></div>
                <div></div>
                <div></div>
            </div>

            <div className={styles.content + ' ' + `${styles['style-content']} ${isOpen ? styles.open : ''}`}>
                <ul>
                    <li><a href="/" onClick={closeMenu}>Início</a></li>
                    <li><a href="#about" onClick={closeMenu}>Sobre</a></li>
                    <li><a href="#portfolio" onClick={closeMenu}>Portfólio</a></li>
                    <li><a href="#participants" onClick={closeMenu}>Participantes</a></li>
                    <li><a href="#contact" onClick={closeMenu}>Contato</a></li>
                </ul>
            </div>
        </div>

    )
}

export default IndividualNavbar;

